import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';

import { RevHeroService } from '@app/src/app/services/RevHero';
import { ScheduleWidgetModule } from '@app/src/app/shared/components/student-schedule-widget/student-schedule-widget.module';

import { FormModule } from '@shared/components/form';
import { PlaceholderModule } from '@shared/components/placeholder/placeholder.module';
import { CommonUIModules } from '@shared/modules';

import { SharedToolsModule } from '../shared-tools/shared-tools.module';
import { AtMyToolsComponent } from './components/at-my-tools/at-my-tools.component';
import { AtRootComponent } from './components/at-root/at-root.component';

@NgModule({
  imports: [
    CommonModule,
    CommonUIModules,
    SharedToolsModule,
    MatMenuModule,
    FormModule,
    PlaceholderModule,
    ScheduleWidgetModule,
  ],
  declarations: [AtRootComponent, AtMyToolsComponent],
  exports: [AtRootComponent, AtMyToolsComponent],
  providers: [RevHeroService],
})
export class AdminToolsModule {}
